import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail } from "../api";
import { toast } from "sonner";
import { ShieldCheck } from "lucide-react";

export default function SetPassword() {
  const { token } = useParams();
  const nav = useNavigate();
  const [state, setState] = useState({ loading: true, valid: false, email: "", nome: "" });
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get(`/portal-auth/invite/${token}`)
      .then(({ data }) => setState({ loading: false, valid: true, email: data.email, nome: data.nome }))
      .catch((e) => { setState({ loading: false, valid: false }); toast.error(formatApiErrorDetail(e.response?.data?.detail)); });
  }, [token]);

  const submit = async () => {
    if (pw.length < 8) return toast.error("A password deve ter no minimo 8 caracteres.");
    if (pw !== pw2) return toast.error("As passwords nao coincidem.");
    setSaving(true);
    try {
      await api.post("/portal-auth/set-password", { token, password: pw });
      toast.success("Password definida. Ja pode entrar.");
      setTimeout(() => nav("/login"), 1200);
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-navy p-4">
      <div className="bg-white rounded-2xl p-8 w-full max-w-md" data-testid="set-password-card">
        <div className="flex items-center gap-2 mb-6">
          <ShieldCheck className="text-blue" size={26} />
          <div className="font-bold text-lg text-navy tracking-tight">SaaS-Hub - Portal do Cliente</div>
        </div>
        {state.loading && <p className="text-muted2 text-sm">A validar convite...</p>}
        {!state.loading && !state.valid && <p className="text-red-600 text-sm">Convite invalido ou expirado. Contacte o seu gestor de conta.</p>}
        {!state.loading && state.valid && (
          <>
            <p className="text-sm text-muted2 mb-4">Ola {state.nome || state.email}, defina a sua password de acesso ao portal.</p>
            <label className="block text-sm font-semibold text-navy mb-1">Nova password</label>
            <input type="password" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="sp-password" className="w-full mb-3 px-3 py-2 border border-tint rounded-lg" />
            <label className="block text-sm font-semibold text-navy mb-1">Confirmar password</label>
            <input type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="sp-password2" className="w-full mb-5 px-3 py-2 border border-tint rounded-lg" />
            <button onClick={submit} disabled={saving} data-testid="sp-submit" className="w-full bg-blue text-white py-2.5 rounded-lg font-semibold hover:bg-[#5BB8E8] transition-colors disabled:opacity-50">
              {saving ? "A guardar..." : "Definir password"}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
